// extracted by css-extract-rspack-plugin
export default {"tabs":"ProcedureCategoryTabs__tabs--MNeHn"};